import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ScheduleDownloadButtonComponent} from './components/schedule-download-button/schedule-download-button.component';
import {SharedModule} from '@helpers/modules/shared.module';
import { ScheduleDownloadMenuComponent } from './components/schedule-download-menu/schedule-download-menu.component';
import {CalibrationScheduleService} from './services/calibration-schedule.service';
import {Lab365CommonModule} from '@lab365/common';

@NgModule({
    declarations: [
        ScheduleDownloadButtonComponent,
        ScheduleDownloadMenuComponent,
    ],
    exports: [
        ScheduleDownloadButtonComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        Lab365CommonModule,
    ],
    providers: [
        CalibrationScheduleService,
    ]
})
export class CalibrationScheduleModule {
}
